import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';

export function DealerReviewThankYou({ children = null, className = null }) {
  return (
    <div className={className}>
      <h1 className="heading-2 my-1_5 d-flex align-items-center" data-test="confirmation-title">
        <i className="icon-envelop3 text-primary me-0_5" aria-hidden />
        One final step!
      </h1>
      <Row>
        <Col xs={12} lg={8}>
          <p data-test="confirmation-copy">
            Please check your email inbox for a confirmation email, and click the verification link to complete the
            submission process. If you have any questions, please{' '}
            <a href="https://help.edmunds.com/hc/en-us/requests/new" rel="nofollow" className="text-underline">
              contact us
            </a>
            .
          </p>
        </Col>
        {children}
      </Row>
    </div>
  );
}

DealerReviewThankYou.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
